/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ left: NonNullable<unknown>, total: NonNullable<unknown> }} Features_Pack_LeftInputs */

const en_features_pack_left = /** @type {(inputs: Features_Pack_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.left} of ${i?.total} left`)
};

const pl_features_pack_left = /** @type {(inputs: Features_Pack_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`zostało ${i?.left} z ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{left} of {total} left" |
*
* @param {Features_Pack_LeftInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_pack_left = /** @type {((inputs: Features_Pack_LeftInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Pack_LeftInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_pack_left(inputs)
	return en_features_pack_left(inputs)
});